import { render, staticRenderFns } from "./DashboardFlip.vue?vue&type=template&id=530cc55e&scoped=true"
import script from "./DashboardFlip.vue?vue&type=script&lang=js"
export * from "./DashboardFlip.vue?vue&type=script&lang=js"
import style0 from "./DashboardFlip.vue?vue&type=style&index=0&id=530cc55e&prod&lang=scss&scoped=true"
import style1 from "./DashboardFlip.vue?vue&type=style&index=1&id=530cc55e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530cc55e",
  null
  
)

export default component.exports